import { render, staticRenderFns } from "./Informational.vue?vue&type=template&id=4d59b360&scoped=true&"
import script from "./Informational.vue?vue&type=script&lang=ts&"
export * from "./Informational.vue?vue&type=script&lang=ts&"
import style0 from "./Informational.vue?vue&type=style&index=0&id=4d59b360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d59b360",
  null
  
)

export default component.exports